<template>
  <div>
    <info  :type="1" :infoType="1" ></info> 
    <!-- type 1 所有用户 2 指定用户的信息
    infoType 1 买的信息  2 卖的信息 -->

  </div>
</template>
<script>
import info from '../../tongyong/adminInfo.vue'
 
export default {

  components: {
    info: info 
  },

  data() {
    return {
      // 获取用户列表参数
      
    };
  },
  props: [],
 
  watch: {
 
  },
  created() {
 
  },
  mounted() {
 
  }
}
</script>
